(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  const choices = new Map();
  const initialized = new WeakSet();
  const message = 'Please select your delivery area';
  function details(select) {
    const picker = select.closest('variant-selects');
    if (!picker) return null;
    const root = picker.closest('.shopify-section') || document;
    const form = Array.from(root.querySelectorAll('form[data-form-id]')).find(el => el.dataset.formId === picker.dataset.productFormId);
    if (!form) return null;
    const key = [picker.dataset.sectionId, picker.dataset.productFormId, picker.dataset.productId].join(':');
    return { picker, form, key };
  }
  function isArea(select) {
    return select.matches('variant-selects select') && Array.from(select.labels || []).some(label => /^delivery area(?:\s*[-–—].*)?$/i.test(label.textContent.trim()));
  }
  function ready(select, info) {
    if (!choices.has(info.key) || !select.value) return false;
    let variant;
    try { variant = JSON.parse(info.picker.querySelector('[data-selected-variant]').textContent); } catch (_) { return false; }
    const position = Number(select.closest('[data-option-position]').dataset.optionPosition) - 1;
    const input = info.form.querySelector('input[name="id"]');
    return !!variant && variant.options[position] === select.value && input && input.value === String(variant.id);
  }
  function sync() {
    document.querySelectorAll('variant-selects select').forEach(select => {
      if (!isArea(select)) return;
      const info = details(select);
      if (!info) return;
      if (!initialized.has(select)) {
        initialized.add(select);
        select.required = true;
        select.dataset.deliveryAreaRequired = 'true';
        if (!choices.has(info.key)) {
          const placeholder = new Option(message, '', true, true);
          placeholder.disabled = true;
          select.prepend(placeholder);
          select.value = '';
        }
        const note = document.createElement('p');
        note.id = select.id + '-required-note';
        note.className = 'delivery-area-required-note';
        note.textContent = 'Choose your delivery area or collection from the farm before adding to your basket.';
        select.closest('fieldset').append(note);
        select.setAttribute('aria-describedby', [select.getAttribute('aria-describedby'), note.id].filter(Boolean).join(' '));
      }
      const pending = !ready(select, info);
      info.form.toggleAttribute('data-delivery-area-pending', pending);
      select.setCustomValidity(!select.value ? message : '');
      info.form.querySelectorAll('[data-submit-button]').forEach(button => {
        if (pending) button.setAttribute('data-delivery-area-blocked', '');
        else button.removeAttribute('data-delivery-area-blocked');
      });
    });
  }
  function guard(event) {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const form = target && target.closest('form[data-form-id]');
    if (!form || (event.type === 'click' && !event.composedPath().some(el => el instanceof Element && el.matches('[data-submit-button], .shopify-payment-button, shopify-accelerated-checkout')))) return;
    sync();
    if (!form.hasAttribute('data-delivery-area-pending')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const select = Array.from(document.querySelectorAll('[data-delivery-area-required]')).find(el => details(el)?.form === form);
    if (select) { select.focus(); if (!select.value) select.reportValidity(); }
  }
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !isArea(select)) return;
    const info = details(select);
    if (info && select.value) choices.set(info.key, select.value);
    sync();
    requestAnimationFrame(sync);
  }, true);
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  sync();
  document.addEventListener('DOMContentLoaded', sync, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
